"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable react-hooks/exhaustive-deps */
var react_1 = require("react");
var useShowCaptions = function (_a) {
    var _b, _c;
    var videoRef = _a.videoRef, campaign = _a.campaign, playingSecondVideo = _a.playingSecondVideo, setCaptionsEnabled = _a.setCaptionsEnabled;
    function timeStringToSeconds(timeString) {
        var _a = timeString.split(':').map(parseFloat), hours = _a[0], minutes = _a[1], seconds = _a[2];
        return hours * 3600 + minutes * 60 + seconds;
    }
    function parseCaptions(text) {
        // Split the text into lines
        var lines = text.split('\n');
        // Initialize an empty array to hold the captions
        var captions = [];
        // Iterate over the lines
        for (var i = 0; i < lines.length; i++) {
            // If the line contains the arrow symbol, it's a time range
            if (lines[i].includes('-->')) {
                // Split the line into start and end times
                var _a = lines[i]
                    .split(' --> ')
                    .map(timeStringToSeconds), startTime = _a[0], endTime = _a[1];
                // The next line is the caption text
                var text_1 = lines[i + 1];
                // Add the caption to the array
                captions.push({ startTime: startTime, endTime: endTime, text: text_1 });
            }
        }
        return captions;
    }
    function getCaptionForTime(captions, time) {
        // Find the caption where the start time is less than the current time
        // and the end time is greater than the current time
        for (var _i = 0, captions_1 = captions; _i < captions_1.length; _i++) {
            var caption = captions_1[_i];
            if (caption.startTime <= time && caption.endTime >= time) {
                return caption.text;
            }
        }
        // If no caption is found, return an empty string
        return '';
    }
    var disableCaptions = function () {
        setCaptionsEnabled(false);
        return;
    };
    react_1.useEffect(function () {
        var meta = campaign.meta, captions = campaign.captions;
        var video = meta.video;
        if (!video || !captions)
            return disableCaptions();
        var muxCaptions = undefined;
        var muxPlaybackId = undefined;
        if (!playingSecondVideo) {
            muxCaptions = video === null || video === void 0 ? void 0 : video.muxCaptions;
            muxPlaybackId = video === null || video === void 0 ? void 0 : video.muxPlaybackId;
        }
        else {
            var assets = meta.assets;
            if (!assets || assets.length === 0)
                return disableCaptions();
            var _a = assets[0], playbackId = _a.muxPlaybackId, captionsInfo = _a.muxCaptions;
            if (!captionsInfo || !playbackId)
                return disableCaptions();
            muxCaptions = captionsInfo;
            muxPlaybackId = playbackId;
        }
        var fetchCaptions = function () { return __awaiter(void 0, void 0, void 0, function () {
            var captionsResponse, captionsText, captions_2, video_1, captionsElement_1, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!muxCaptions || muxCaptions.length === 0)
                            return [2 /*return*/, disableCaptions()];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, fetch("https://stream.mux.com/" + muxPlaybackId + "/text/" + muxCaptions[0].id + ".vtt")];
                    case 2:
                        captionsResponse = _a.sent();
                        if (!captionsResponse.ok)
                            return [2 /*return*/, disableCaptions()];
                        setCaptionsEnabled(true);
                        return [4 /*yield*/, captionsResponse.text()];
                    case 3:
                        captionsText = _a.sent();
                        captions_2 = parseCaptions(captionsText);
                        video_1 = videoRef.current;
                        captionsElement_1 = document.querySelector('#sendspark-player-video-captions');
                        if (video_1) {
                            video_1.addEventListener('timeupdate', function () {
                                var caption = getCaptionForTime(captions_2, video_1.currentTime);
                                captionsElement_1.textContent = caption;
                            });
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        error_1 = _a.sent();
                        console.error('Error trying to fetch video captions: ', error_1);
                        disableCaptions();
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        fetchCaptions();
    }, [videoRef, playingSecondVideo, (_c = (_b = campaign === null || campaign === void 0 ? void 0 : campaign.meta) === null || _b === void 0 ? void 0 : _b.video) === null || _c === void 0 ? void 0 : _c.muxCaptions, campaign === null || campaign === void 0 ? void 0 : campaign.captions]);
};
exports.default = useShowCaptions;
